{
  "more": "その他の項目"
}
